<template>
  <div class="information-total-pay">
    <el-descriptions class="host-list-top" size="medium" border label-class-name="descriptions-label"
      content-class-name="descriptions-content" :labelStyle="{ width: '120px' }">
      <el-descriptions-item :contentStyle="{ width: '150px' }">
        <template slot="label">
          <i class="el-icon-coin"></i>
          实收总费用
        </template>
        <span class="money_red" v-if="totalPayMoney > 0"> {{ totalPayMoney }} 元 </span>
        <span v-else class="gray">0</span>
      </el-descriptions-item>
  </el-descriptions>

    <div class="table_title">信息完善报表总费用详情</div>
    <StudentsTableHeader id="InformationImprovementTotalPay" :empty-text="emptyText" :table-height="tableMaxHeight"
      componentTableId="InformationImprovementTotalPay" excelName="信息完善报表总费用详情" :header-data="headerData" :table-data="tableData"
      :pagination="pagination" @update-list="getData" :table-loading="tableLoading" :element-loading-text="loadingText"
      @handleSelectionChange1="handleSelectionChange" @handleCard="openDialog" @search-data="tableSearch"  @search-remote ="searchRemote">
      <template v-slot:productTitlecustom="scope">
        <span>{{ scope.scope.productTitle }}</span>
      </template>
      <template v-slot:moneyPercentcustom="scope">
        <span>{{ scope.scope.moneyPercent + '%' }}</span>
      </template>
      <template v-slot:moneycustom="scope">
        <span>{{ scope.scope.money + '元' }}</span>
      </template>
      <template v-slot:payMoneycustom="scope">
        <span v-if="scope.scope.payMoney || scope.scope.payMoney === 0">{{ scope.scope.payMoney + '元' }}</span>
        <span v-else class="grey">未设置</span>
      </template>
      <template v-slot:realMoneycustom="scope">
        <span v-if="scope.scope.realMoney || scope.scope.realMoney === 0">{{ scope.scope.realMoney + '元' }}</span>
        <span v-else class="grey">未设置</span>
      </template>
      <template v-slot:currentMonthRefundMoneycustom="scope">
        <span v-if="scope.scope.refundState > 0">{{ scope.scope.currentMonthRefundMoney || '0' }}元</span>
        <span v-else>/</span>
      </template>
      <template v-slot:remarkscustom="scope">
        <span class="blue" style="cursor:pointer">{{ scope.scope.remarks && scope.scope.remarks[0] }}</span>
      </template>
      <template v-slot:agreementStatecustom="scope">
        <el-tag>{{ scope.scope.agreementStateName || scope.scope.agreementState }}</el-tag>
      </template>
      <template v-slot:isCommoncustom="scope">
        <el-tag :type="scope.scope.isCommon ? 'danger' : 'info'">{{ scope.scope.isCommon ? '是' : '否' }}</el-tag>
      </template>
      <template v-slot:refundStateNamecustom="scope">
        <el-tooltip v-if="scope.scope.refundState != 0" class="item" effect="dark" placement="bottom" :content="scope.scope.refundState === 1 ?
          contentTip1 : contentTip">
          <div slot="content" v-if="scope.scope.refundState === 2">{{ contentTip2 }}<br />{{ contentTip22 }}</div>
          <div slot="content" v-if="scope.scope.refundState === 3">{{ contentTip3 }}<br />{{ contentTip32 }}</div>
          <el-tag :type="scope.scope.refundState === 3 ?
            'warning' : scope.scope.refundState === 2 ?
              'warning' : scope.scope.refundState === 1 ?
                'info' : 'success'">
            {{ scope.scope.refundStateName }}
          </el-tag>
        </el-tooltip>
        <span v-else>
          <el-tag :type="scope.scope.refundState === 3 ?
            'warning' : scope.scope.refundState === 2 ?
              'warning' : scope.scope.refundState === 1 ?
                'info' : 'success'">
            {{ scope.scope.refundStateName }}
          </el-tag>
        </span>
      </template>
    </StudentsTableHeader>
    <pagination-tool :pagination="pagination" :is-loading="tableLoading" @change-pagination="changePagination" />
  </div>
  </template>

  <script>
import StudentsTableHeader from 'components/StudentList'
import PaginationTool from 'components/PaginationTool'
import { GetAchievementPageListWithTotal } from '@/network/statistics.js'
import { getAdminList } from 'network/administrator'
import { isNull } from '../../common/utils'
export default {
  name: 'InformationImprovementTotalPay',
  components: { StudentsTableHeader, PaginationTool },
  data() {
    return {
      emptyText: '暂无数据',
      tableData: [],
      tableLoading: false,
      loadingText: 'loading...',
      totalPayMoney: null,
      pagination: { currentPage: 1, pageSize: 20, total: 0 },
      query: {
        AdminId: 0,
        StudentName: null,
        IsReApply: null,
        TelNumber: null,
        ProductIds: [],
        ProductTitle: null,
        StatrTime: null,
        EndTime: null,
        AgreementState: 0,
        OrderType: null,
        RefundState: null,
        RefundStates: [0,2], //0-绩效状态正常，2-退有
        IsCommon: null,
        SourceIds: [],
        MarketingId: null,
        OperationId: null,
      },
      // 老师列表
      businessList: [],
      marketingList: [],
      operationList: [],
      headerData: [
        // { label: '勾选框', type: 'selection', align: 'center', width: '55', fixed: 'left' },
        { label: '学员姓名', prop: 'studentName', width: '120', align: 'left', fixed: 'left', noSetText: "未设置", noTooltip: true, inputSlot: true, inputSearch: true, studentName: null },
        { label: '手机号', prop: 'telNumber', width: '120', align: 'center', noTooltip: true, noSetText: "未设置",inputSlot: true, inputSearch: true, telNumber: null },
        { label: '报名课程', prop: 'productTitle', width: '200', align: 'left', custom: true, noTooltip: true, inputSlot: true, inputSearch: true, productTitle: null },
        { label: '订单类型', prop: 'orderTypeName', width: '120', align: 'center' },
        { label: '所属业务老师', prop: 'adminName', width: '180', align: 'center', noSetText: "未设置", noTooltip: true,clearable: true, selectSearch: true, adminName: null, selectOptions: "",remoteMethod: true,},
        { label: '所属网络营销老师', prop: 'marketingName', width: '180', align: 'center', noSetText: "未设置", noTooltip: true,clearable: true, selectSearch: true, marketingName: null, selectOptions: "",remoteMethod: true,},
        { label: '所属用户运营老师', prop: 'operationName', width: '180', align: 'center', noSetText: "未设置", noTooltip: true,clearable: true, selectSearch: true, operationName: null, selectOptions: "",remoteMethod: true,},
        { label: '绩效状态', prop: 'refundStateName', width: '80', align: 'center', custom: true },
        { label: '是否撞单', prop: 'isCommon', width: '80', align: 'center', custom: true },
        { label: '来源渠道', prop: 'source', width: '220', align: 'center' },
        { label: '业绩金额', prop: 'payMoney', width: '90', align: 'center', custom: true },
        { label: '实付金额', prop: 'realMoney', width: '90', align: 'center', custom: true },
        { label: '退费金额', prop: 'currentMonthRefundMoney', width: '90', align: 'center', custom: true },
        { label: '实际提成金额', prop: 'money', width: '110', align: 'center', custom: true },
        { label: '提成百分比(%)', prop: 'moneyPercent', width: '120', align: 'center', custom: true },
        { label: '发生时间', prop: 'createTime', width: '160', align: 'center' },
        { label: '备注说明', prop: 'remarks', align: 'center', custom: true },
        // { label: '协议签订状态', prop: 'agreementState', width: '120', align: 'center', custom: true },
      ],
      handleSelection: [],
      studentId: 0,
    }
  },
  created() {
    this.initQueryFromRoute()
    this.getData()
  },
  mounted() {
  },
    computed: {
    tableMaxHeight() {
      const h = document.documentElement.clientHeight || document.body.clientHeight;
      if (h > 768) {
        return h - 160;
      } else {
        return h + 100;
      }
    },
  },
  methods: {
    async searchRemote(val){
      let businessRoleId = this.$store.state.allConfig.businessRoleId
      let educationalRoleId = this.$store.state.allConfig.educationalRoleId
      let operationRoleId = this.$store.state.allConfig.operationRoleId
      let marketingRoleId = this.$store.state.allConfig.marketingRoleId
      let data = {
        ids: [],
        keyWord: val.value,
        pageSize: 50,
        adminTypeIds: []
      };
      if(val.prop === 'operationName'){
        data.adminTypeIds = [operationRoleId]
      }else if(val.prop === 'marketingName'){
        data.adminTypeIds = [marketingRoleId]
      }else if(val.prop === 'adminName'){
        data.adminTypeIds = [educationalRoleId, businessRoleId, operationRoleId, marketingRoleId]
      }
      let res = await getAdminList(data);
        for (let item of this.headerData) {
          if (item.prop === val.prop) {
            item.selectOptions = res.result;
            item.selectOptions.unshift({ id: 0, name: "全部" });
          }
        }
    },
    initQueryFromRoute() {
      const q = this.$route?.query || {}
      if (q.beginTime) this.query.StatrTime = q.beginTime
      if (q.endTime) this.query.EndTime = q.endTime
      if (q.SourceIds) {
        try { this.query.SourceIds = JSON.parse(q.SourceIds) } catch (e) {}
      }
    },
    async getData() {
      if (this.tableLoading) return
      this.tableLoading = true
      const params = {
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        AdminId: this.query.AdminId || 0,
        StudentName: this.query.StudentName,
        TelNumber: this.query.TelNumber,
        AgreementState: this.query.AgreementState,
        RefundState: this.query.RefundState,
        IsCommon: this.query.IsCommon,
        ProductTitle: this.query.ProductTitle,
        StatrTime: this.query.StatrTime,
        EndTime: this.query.EndTime,
        orderType: this.query.OrderType,
        ProductTuples: this.query.ProductIds,
        SourceIds: this.query.SourceIds,
        RefundStates: this.query.RefundStates,
        MarketingId: this.query.MarketingId,
        OperationId: this.query.OperationId,
      }
      try {
        const res = await GetAchievementPageListWithTotal(params)
        this.tableLoading = false
        if (res && res.code === 1) {
          this.tableData = res.result?.data || []
          this.pagination.total = res.result?.totalCount || res.totalCount || 0
          this.totalPayMoney = res.result?.totalPayMoney ?? null
        } else {
          this.tableData = []
          this.pagination.total = 0
          this.totalPayMoney = null
          this.$alert(res.message || '加载失败')
        }
      } catch (e) {
        this.tableLoading = false
        this.$alert('加载失败')
      }
    },
    changePagination() {
      this.getData()
    },
    tableSearch(val) {
      if (val && val.prop === 'studentName') {
        this.query.StudentName = val.value || null
      }
      if (val && val.prop === 'telNumber') {
        this.query.TelNumber = val.value || null
      }
      if (val && val.prop === 'productTitle') {
        this.query.ProductTitle = val.value || null
      }
      if (!isNull(val.prop) && val.prop === 'adminName') {
        this.query.AdminId = val.value || 0
      }
      if (!isNull(val.prop) && val.prop === 'marketingName') {
        this.query.MarketingId = val.value || null
      }
      if (!isNull(val.prop) && val.prop === 'operationName') {
        this.query.OperationId = val.value || null
      }
      this.pagination.currentPage = 1
      this.getData()
    },
    handleSelectionChange(val) { this.handleSelection = val },
    openDialog(row) { this.studentId = row.studentId },

  }
}
  </script>

  <style scoped>
  .money_red { color: #ff1717; font-weight: 600; }
  .information-total-pay { padding: 20px; padding-right: 10px !important; }
  .table_title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #ececec;
    text-align: center;
    font-weight: bold;
    margin-top: 10px;
  }
  .host-list-top { margin-top: -10px; }
  .host-list-top ::v-deep .el-descriptions__table { width: 240px !important; }
  ::v-deep .el-table { margin-top: 0 !important; }
  </style>
